(function () {
	angular
		.module('trackeye')
		.factory('SutMessageCollection', _SutMessageCollectionFactory);

	_SutMessageCollectionFactory.$inject = ["SutMessage", "$q", "HttpQueue"];

	function _SutMessageCollectionFactory(SutMessage, $q, HttpQueue) {
		function SutMessageCollection() {
			this.uuid = generateUUID();
			this.sutmessages = [];
			this.promises = [];
		}

		/**
		 * Add a sutmessage to the list, by passing either a sutmessage
		 * Resource object, or a SutMessage instance.
		 *
		 *  @param {...Resource|...SutMessage}
		 */
		SutMessageCollection.prototype.addMany = function () {
			for (var i = 0; i < arguments.length; i++) {
				var data = arguments[i];

				// If passed param, is not an array, convert it to one.
				if (!(data instanceof Array))
					data = [data];

				this._addManyToCollection(data);
			}
		};

		SutMessageCollection.prototype.hasConsumption = function () {
			return !!this.sutmessages.find(function(message) {
				return !!message.consumption.capacityPercentage
			});
		}
		/**
		 * Adds an array of sutmessage Resources or instances, to the list.
		 *
		 * @param {Resource[]|SutMessage[]} [messages=Resource] - An array of Resources/SutMessages
		 */
		SutMessageCollection.prototype._addManyToCollection = function (messages) {
			// reverse the array, to ensure the addresses will load from top, when viewing data.
			for (var i = 0; i < messages.length; i++) {
				var message = messages[i];
				if ((message instanceof SutMessage)) {
					message.setCollectionId(this.uuid);
					this.promises.push(message.fetchAddress());
				} else {
					message = new SutMessage(message, this.uuid);
					this.promises.push(message.fetchAddress());
				}
				if (!this.has(message)) {
					this.sutmessages.push(message);
				} else {
					//Discarded message
				}
			}

			this.sortSutmessagesByDate();
		};

		/**
		 * Returns a promise when the sutmessages in the collection
		 * has finished loading
		 * @returns {Promise}
		 */
		SutMessageCollection.prototype.ready = function () {
			return $q.all(this.promises).finally((function () {
				this.promises = [];
			}).bind(this));
		};

		/**
		 * Asserts if the collection, has any good messages
		 * @returns {boolean}
		 */
		SutMessageCollection.prototype.anyGood = function () {
			return this.sutmessages.some(function (message) {
				return message.id;
			});
		};

		/**
		 * Post-adding messages to the list, these will be checked
		 * against the current items, and discarded if duplicate.
		 *
		 * @param {...SutMessage}
		 */
		SutMessageCollection.prototype.postAddMore = function () {
			for (var i = 0; i < arguments.length; i++) {
				var message = arguments[i];

				if ((message instanceof SutMessage)) {
					this._addNonDuplicate(message);
				}
			}

			this.sortSutmessagesByDate();
		};

		/**
		 * Adds a message to the list, if not exists
		 *
		 * @param {SutMessage} [message=SutMessage]
		 * @returns {boolean}
		 */
		SutMessageCollection.prototype._addNonDuplicate = function (message) {
			message.setCollectionId(this.uuid);
			if (!this.count()) {
				// Collection empty, adding latest message
				this.sutmessages.push(message);
				return true;
			} else {
				// Compare the latest message, with the one being added
				var latest = this.latest();

				if (message.getTime() > latest.getTime()) {
					this.sutmessages.push(message);
					return true;
				} else {
					// message discarded
				}
			}
			return false;
		};

		/**
		 * Return all sutmessages as an array
		 *
		 * @return {Array}          Array of SutMessage instances.
		 */
		SutMessageCollection.prototype.all = function () {
			return this.sutmessages;
		};

		SutMessageCollection.prototype.latest = function () {
			return this.first();
		};

		/**
		 * Return the first sutmessage of the list
		 *
		 * @return {SutMessage}
		 */
		SutMessageCollection.prototype.first = function () {
			return this.sutmessages[0];
		};

		/**
		 * Return the last sutmessage of the list
		 *
		 * @return {SutMessage}
		 */
		SutMessageCollection.prototype.last = function () {
			return this.sutmessages[this.count() - 1];
		};

		SutMessageCollection.prototype.sortSutmessagesByDate = function () {
			this.sortByDate('sutmessages');
		};

		/**
		 * Sort given list by date, descending.
		 *
		 * @return void
		 */
		SutMessageCollection.prototype.sortByDate = function (list) {
			this[list].sort(function (sut1, sut2) {
				var date1 = sut1.getTime(),
					date2 = sut2.getTime();

				if (date1 > date2) {
					return -1;
				} else if (date1 < date2) {
					return 1;
				}
				return 0;
			});
		};

		SutMessageCollection.prototype.resolvedAddressesCheck = function () {
			for (var i = 0; this.sutmessages.length > i; i++) {
				var message = this.sutmessages[i];

				if (message.isAddressResolved())
					continue;

				message.fetchAddress();
			}
		};

		SutMessageCollection.prototype.cancelAddressQueue = function () {
			HttpQueue.cancel(this.uuid);
		};

		/**
		 * Checks if a SutMessage exists in the list
		 *
		 * @param {SutMessage} new_message
		 * @returns {boolean}
		 */
		SutMessageCollection.prototype.has = function (new_message) {
			return !!this.sutmessages.filter(function (message) {
				return new_message.getId() === message.getId();
			}).length;
		};

		/**
		 * Return the number of sutmessages in list
		 * @return {Number}
		 */
		SutMessageCollection.prototype.count = function () {
			return this.sutmessages.length;
		};

		/**
		 * Asserts if there's anything in the buffer array
		 * @returns {boolean}
		 */
		SutMessageCollection.prototype.hasBuffer = function () {
			return !!this.countBuffer();
		};

		/**
		 * Gets number of items in the buffer
		 * @returns {Number}
		 */
		SutMessageCollection.prototype.countBuffer = function () {
			return this.buffer.length;
		};

		SutMessageCollection.prototype.getCollectionId = function () {
			return this.uuid;
		};

		return SutMessageCollection;
	}
})();